import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "../hooks";
import { ENV } from "../utils";

// Creamos el contexto
const CompanyContext = createContext();

// Proveedor del contexto
export const CompanyProvider = (props) => {
  const { children } = props;
  const { user, accessToken } = useAuth();
  const [company, setCompany] = useState(() => {
    const storedCompany = localStorage.getItem("company");
    return storedCompany ? storedCompany : "";
  });
  const [companyIndustry, setCompanyIndustry] = useState(null);

  const changeCompany = (newCompany) => {
    setCompany(newCompany);
  };

  useEffect(() => {
    localStorage.setItem("company", company);
  }, [company]);

  // Resetear cuando el usuario cierra sesión, cargar desde localStorage al iniciar
  useEffect(() => {
    if (user) {
      const storedCompany = localStorage.getItem("company");
      if (storedCompany) {
        setCompany(storedCompany);
      }
    } else {
      setCompany("");
      setCompanyIndustry(null);
    }
  }, [user]);

  // Resolver industria de la empresa activa
  useEffect(() => {
    if (!company || company === "0" || !accessToken) {
      setCompanyIndustry(null);
      return;
    }
    fetch(`${ENV.BASE_API}/company/${company}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((r) => r.ok ? r.json() : null)
      .then((data) => setCompanyIndustry(data?.industry || null))
      .catch(() => setCompanyIndustry(null));
  }, [company, accessToken]);

  return (
    <CompanyContext.Provider value={{ company, changeCompany, companyIndustry }}>
      {children}
    </CompanyContext.Provider>
  );
};

// Hook personalizado para consumir el contexto
export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompany debe ser usado dentro de un CompanyProvider");
  }
  return context;
};
